<div class="row text-primary py-4 container-fluid mx-auto">
  <div class="col-12 col-md-2">
    <div class="bg-white rounded p-3 text-center mb-3">
      <h4>Questions</h4>
      <div class="d-flex justify-content-center align-items-center flex-wrap mt-2">
        <ng-container *ngFor="let item of questions; index as i; trackBy: trackByIndex">
          <ng-container *ngFor="let question of item.questions; index as j; trackBy: trackByIndex">
            <div class="question-pin shadow rounded-circle d-flex justify-content-center align-items-center bolder m-2"
                 [class.bg-primary]="isAnswered(question)"
                 [class.text-white]="isAnswered(question)">
              {{ getIndex(i, j) }}
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-10">
    <div class="bg-white rounded p-4">
      <h4 class="mb-2">Part 7 - Reading Comprehension</h4>
      <p>
        In this part, you will read passages in the form of emails, letters, ads, memos, forms, schedules, receipts, articles, text messages, etc. For each question, choose the answer which you think fits best according to what you hear.
      <p>
        There are 54 questions in this test.
      </p>
    </div>

    <!-- Questions -->
    <div class="bg-white rounded p-4 mt-3" *ngFor="let item of questions; index as i; trackBy: trackByIndex">
      <h5 class="mb-3 bolder">{{ i+1 }}.</h5>
      <div class="row my-2">
        <div class="col-12 col-md-6">
          <p [innerHTML]="item.question.translation"></p>
        </div>
        <div class="col-12 col-md-6 d-flex flex-column justify-content-start">
          <ng-container *ngFor="let question of item.questions; index as indexSentence; trackBy: trackByIndex">
            <div class="my-4">
              <h5 class="mb-2">{{indexSentence+1}}. {{question.translation}}</h5>
              <ng-container *ngFor="let answer of question.answers; let sentenceIndex = index; trackBy: trackByIndex">
                <button class="btn rounded btn-block shadow bolder mx-2 text-left p-3 d-flex align-items-center"
                        [class.btn-primary]="isSelected(question, answer)"
                        [class.text-white]="isSelected(question, answer)"
                        [class.btn-white]="!isSelected(question, answer)"
                        [class.text-primary]="!isSelected(question, answer)"
                        (click)="selectAnswer(question, answer)">
                  <span class="mr-3 bolder">{{ letters[sentenceIndex] }}</span> {{answer.translation}}
                </button>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </div>


    <button class="btn btn-primary btn-block bolder mt-3" (click)="next()" translate>Suivant</button>
  </div>
</div>
